/**
 * api接口的统一出口
 */
// 首页模块接口
import home from "@/api/home";
import commodity from "@/api/commodity";
import strategy from "@/api/strategy";
// 其他模块的接口……
import author from "@/api/author";
import activity from "@/api/activity";
import order from "@/api/order";
// 导出接口
export default {
  home,
  commodity,
  strategy,
  author,
  activity,
  order
  // ……
};



// WEBPACK FOOTER //
// ./src/api/index.js